
import ThreatGuardIcon from "../../assets/sidebarAssets/ThreatGuardIcon";
import IntelligenceReportsIcon from "../../assets/sidebarAssets/IntelligenceReportsIcon";
import DemoEnvironmentIcon from "../../assets/sidebarAssets/DemoEnvironmentIcon";
import ReportIcon from "../../assets/admin-assets/ReportIcon";

const entry = (title = "", target = "/", icon = <ThreatGuardIcon/>) => ({
  title,
  target,
  icon,
});

export const entriesHomePage = {
  "home": [
    entry("DemoPoint", "/demo-point", <DemoEnvironmentIcon/>),
    entry("Intelligence Reports", "/intelligence-reports", <IntelligenceReportsIcon/>),
    // entry("ThreatGuard", "/threatguard", <ThreatGuardIcon/>)
  ],
  "admin": [
    entry("Demo Point Blueprints", "/admin/blueprints", <DemoEnvironmentIcon/>),
    entry("Reports", "/admin/reports", <ReportIcon/>),
  ],
  "reportsAdmin": [
    entry("Reports", "/admin/reports", <ReportIcon/>),
  ],
  "public": [
    entry("DemoPoint", "/demo-point", <DemoEnvironmentIcon/>),
  ]
};
